import { DateTime } from "luxon";
import { IEntitySimpleDTO } from "../@types/common";

export interface ICashRegisterViewDTO {
    readonly idGlobal: string
    readonly idCashRegister: string
    readonly nameCashRegister: string
    readonly numberCashRegister: string
    readonly posVersion: string
    readonly availableF3PosVersion: string
    readonly contractorName: string
    readonly dateCreated: DateTime
    readonly dateModified: DateTime
    readonly dateDeleted?: DateTime
    readonly companyId: string
    readonly deleted: boolean
    readonly idAccessPointGlobal?: string
    readonly isAutoUpdate: boolean
}

export interface ICashRegisterDTO {
    readonly idGlobal: string,
    readonly idCashRegister: string,
    readonly nameCashRegister: string,
    readonly contractorName: string,
    readonly accessPoint?: IEntitySimpleDTO,
    readonly idContractorGlobal: string,
    readonly idRegistratorOfDisposalGlobal: string,
    readonly producerNumber: string,
    readonly numberCashRegister: string,
    readonly posVersion: string
    readonly additionalInformation: string,
    readonly rvEnable: boolean,
    readonly useRawKiz: boolean,
    readonly deleted: boolean,
    readonly dateCreated: DateTime,
    readonly dateModified: DateTime,
    readonly dateDeleted?: DateTime,
    readonly companyId: string,
    readonly kkmDisabled: boolean,
    readonly enableMixPayment: boolean
    readonly enableAcquiring:boolean
    readonly enableProvisorInterface:boolean
    readonly askBeforeChequePrint:boolean
    readonly visualProcessingRV: boolean
    readonly printDiscountSettings: IPrintDiscountSettingsDto
    readonly printSectionReport: boolean
    readonly useTSPIoT: boolean
    readonly urlTSPIoT: string
    readonly idTSPIoTWin: string
    readonly idTSPIoTLin: string
    readonly isControlValidDate: boolean
    readonly daysStopSaleUnvalidDate: number
    readonly timeOut: number
    readonly allowGoodsOGV: boolean
    readonly messageOGV: string
    readonly endText: string
    readonly isAutoUpdate: boolean
    readonly versionTSPIoT: versionTSPIoT
    readonly availableF3PosVersion: string
    readonly offlineToken: string
    readonly offlineLogin: string
    readonly offlinePassword: string
    readonly offlineServer: string
    readonly offlinePort: string
    readonly offlineVersion: offlineVersion
    readonly offlineRegimeEnabled: boolean
    readonly allowChequePrintLMCZNoAnswer: boolean
}

export enum offlineVersion {
    VER_11="VER_1.1",
    VER_12="VER_1.2",
    VER_21="VER_2.1"
}

export enum versionTSPIoT {
    VER_1="VER_1",
    VER_2="VER_2",
    VER_3="VER_3"
}

export interface ICashRegisterCreate {
    idGlobal: string,
    nameCashRegister: string,
    idContractorGlobal: string
    idRegistratorOfDisposalGlobal: string,
    producerNumber: string,
    numberCashRegister: string,
    additionalInformation: string,
    rvEnable: boolean,
    useRawKiz: boolean,
    kkmDisabled: boolean,
    accessPoint?: IEntitySimpleDTO,
    enableMixPayment: boolean
    enableAcquiring:boolean
    enableProvisorInterface:boolean
    askBeforeChequePrint:boolean
    visualProcessingRV: boolean
    printDiscountSettings: IPrintDiscountSettingsDto
    printSectionReport: boolean
    useTSPIoT: boolean
    urlTSPIoT: string
    idTSPIoTWin: string
    idTSPIoTLin: string
    isControlValidDate: boolean
    daysStopSaleUnvalidDate: number
    timeOut: number
    allowGoodsOGV: boolean
    messageOGV: string
    endText: string
    isAutoUpdate: boolean
    versionTSPIoT: versionTSPIoT
    posVersion?: string
    offlineToken: string
    offlineLogin: string
    offlinePassword: string
    offlineServer: string
    offlinePort: string
    offlineVersion: offlineVersion
    offlineRegimeEnabled: boolean
    allowChequePrintLMCZNoAnswer: boolean
}

interface IPrintDiscountSettingsDto {
     printTypeOfDiscount: string
     printPriceForItemWithoutDiscount: boolean
     printSummForItemWithoutDiscount: boolean
     printSummDiscount: boolean
     printSummForChequeWithoutDiscount: boolean
     printDiscountForItem: boolean
}

export interface IAdditionalSettingsViewDTO {
    readonly idGlobal: string
    readonly serialNumber: number
    readonly setting: string
    readonly value?: boolean
    readonly data?: IPrintDiscountSettingsDto
}